import { AnyAction, ThunkMiddleware, type Middleware } from '@reduxjs/toolkit'
import {
  InsuranceOrdinality,
  type RootStateWithPatientAuth,
  patientAuthActions,
  patientRegistrationApi,
  patientRegistrationExternalApi,
  verifyApiExternal,
} from '@valerahealth/rtk-query'

import {
  reducerPath,
  actions,
  type AppState,
  AppActionPayloads,
} from './appSlice'

export const InsuranceOrdinalityArr = [
  InsuranceOrdinality.Primary,
  InsuranceOrdinality.Secondary,
  InsuranceOrdinality.Tertiary,
]

type RootState = {
  [reducerPath]: AppState
} & RootStateWithPatientAuth & {
    [patientRegistrationApi.reducerPath]: ReturnType<
      typeof patientRegistrationApi.reducer
    >
    [patientRegistrationExternalApi.reducerPath]: ReturnType<
      typeof patientRegistrationExternalApi.reducer
    >
    [verifyApiExternal.reducerPath]: ReturnType<
      typeof verifyApiExternal.reducer
    >
  }

export const appMiddleware: Middleware<AnyAction, RootState> =
  ({ dispatch, getState }) =>
  (next) =>
  (
    action: ReturnType<
      (typeof patientAuthActions)[keyof typeof patientAuthActions]
    >,
  ) => {
    next(action)
    const { returnUrl, returnType } = getState().app.onboarding
    // add the jwt to the return url when it updates
    if (
      action.type === 'patientAuth/setAuthState' &&
      action.payload &&
      returnUrl &&
      returnType === 'mobile'
    ) {
      dispatch(
        // add the JWT to the mobile app return url so that the user can authenticate once back in the app
        actions.setReturnUrl({
          // if query params are already set on the returnUrl we want to replace them
          returnUrl: `${returnUrl.split('?')[0]}?${new URLSearchParams({
            jwt: action.payload,
          })}`,
          returnType,
        }),
      )
    }
  }

export const insuranceVerificiationMiddleware: ThunkMiddleware<
  RootState,
  AnyAction
> =
  ({ getState, dispatch }) =>
  (next) =>
  async (action: AppActionPayloads) => {
    next(action)
  }
